'use client';

import { Container } from 'react-bootstrap';

import { useTranslations } from 'next-intl';

import FiltersSVG from '@/icons/FilterSVG';

import { useFilterMovieContext } from '@/views/FilteredMoviesView/contexts/useFilterMovieContext';
import { useMovies } from '@/views/MoviesView/useMovies';

import { MovieApi } from '@/api/domains/movie.api';

import { IconButton } from '@/components/Buttons';
import { LoaderButton } from '@/components/LoaderButton';
import { MovieList } from '@/components/MovieList';
import { MovieListSkelton } from '@/components/MovieList/MovieListSkelton';
import { SectionHeading } from '@/components/SectionHeading';

import styles from '@/views/MoviesView/MoviesView.module.scss';

// =================================================================

export const MoviesView = () => {
  const { data, handleButtonClick, hasNextPage, isLoading, ref } = useMovies();
  const { toggleFiltersModal } = useFilterMovieContext();

  const t = useTranslations('common');

  if (!data) {
    return (
      <div className={styles.moviesPanel}>
        <Container>
          <MovieListSkelton shouldRemoveHeader />
        </Container>
      </div>
    );
  }

  return (
    <div className={styles.moviesPanel}>
      <Container>
        <MovieList
          movies={MovieApi.extractMoviesData(data.list)}
          rightTopPanel={
            <div className={styles.filterButtonWrapper}>
              <SectionHeading as="h1">{t('filter')}</SectionHeading>
              <IconButton
                as="button"
                icon={FiltersSVG}
                iconWidth={25}
                iconHeight={25}
                onClick={toggleFiltersModal}
                className={styles.filtersButton}
              />
            </div>
          }
        />
        <div className="mb-5">
          {hasNextPage && (
            <LoaderButton ref={ref} isLoading={isLoading} onClick={handleButtonClick} />
          )}
        </div>
      </Container>
    </div>
  );
};
